(function () {
  var CONSENT_COOKIE = 'bw_cookie_consent';
  var CONSENT_DAYS = 180;

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function updateShopifyPrivacy(accepted) {
    if (!window.Shopify || !window.Shopify.customerPrivacy || !window.Shopify.customerPrivacy.setTrackingConsent) {
      return;
    }
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted,
      },
      function () {}
    );
  }

  function activateDeferredTracking() {
    var scripts = document.querySelectorAll('script[type="text/plain"][data-consent="tracking"]');
    scripts.forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) {
        if (attr.name !== 'type' && attr.name !== 'data-consent') {
          script.setAttribute(attr.name, attr.value);
        }
      });
      script.text = oldScript.text;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function notifyConsentUpdate(value) {
    window.dispatchEvent(new CustomEvent('bw:consent-updated', { detail: { consent: value } }));
  }

  function applyConsent(value) {
    var accepted = value === 'accepted';
    setCookie(CONSENT_COOKIE, value, CONSENT_DAYS);
    window.bwCookieConsent = value;
    updateShopifyPrivacy(accepted);
    if (accepted) {
      activateDeferredTracking();
    }
    notifyConsentUpdate(value);
  }

  window.bwCanTrack = function () {
    return getCookie(CONSENT_COOKIE) === 'accepted';
  };

  window.bwRunWhenTrackingConsent = function (callback) {
    if (window.bwCanTrack()) {
      callback();
      return;
    }
    window.addEventListener('bw:consent-updated', function (event) {
      if (event.detail && event.detail.consent === 'accepted') {
        callback();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('bwCookieBanner');
    if (!banner) return;

    var acceptBtn = banner.querySelector('[data-cookie-action="accept"]');
    var declineBtn = banner.querySelector('[data-cookie-action="decline"]');
    var currentChoice = getCookie(CONSENT_COOKIE);

    if (!currentChoice) {
      banner.classList.add('is-visible');
      updateShopifyPrivacy(false);
    } else {
      window.bwCookieConsent = currentChoice;
      if (currentChoice === 'accepted') {
        activateDeferredTracking();
        updateShopifyPrivacy(true);
      } else {
        updateShopifyPrivacy(false);
      }
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        applyConsent('accepted');
        banner.classList.remove('is-visible');
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        applyConsent('declined');
        banner.classList.remove('is-visible');
      });
    }
  });
})();
